import { render, staticRenderFns } from "./HomeHeading.vue?vue&type=template&id=a647df58&lang=pug&"
import script from "./HomeHeading.vue?vue&type=script&lang=js&"
export * from "./HomeHeading.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports